import { combineReducers } from '@reduxjs/toolkit';

import { ISignUpFormState, SignUpFormReducers } from '../SignUpForm/reducers';
import { IThanksForRegisteringState, ThanksForRegisteringReducers } from '../ThanksForRegistering/reducers';

export const EmbeddedSignUpFormReducers = combineReducers({
    signUpForm: SignUpFormReducers,
    thanksForRegistering: ThanksForRegisteringReducers,
});

export interface IEmbeddedSignUpFormState {
    signUpForm : ISignUpFormState;
    thanksForRegistering : IThanksForRegisteringState;
}
